import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

const Tag = ({ classes, children, ...rest }) => {
  return (
    <span
      className={classNames({
        [classes.tag]: true,
        [rest.className]: rest.className
      })}
    >
      {children}
    </span>
  );
};

Tag.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired
};

const styles = theme => ({
  tag: {
    borderRadius: theme.layout.borderRadius,
    fontSize: 10,
    color: theme.colors.white,
    fontWeight: 600,
    padding: 6,
    display: "inline-block",
    verticalAlign: "middle",
    textTransform: "uppercase",
    lineHeight: "normal"
  }
});

export default injectSheet(styles)(Tag);



// WEBPACK FOOTER //
// ./src/components/shared/Tag.js